import { render } from "./Kanban.vue?vue&type=template&id=40f603a6"
import script from "./Kanban.vue?vue&type=script&lang=js"
export * from "./Kanban.vue?vue&type=script&lang=js"
script.render = render

export default script